import React, { useState } from "react";
import {
  MainButton,
  Subtitle,
  TextBold,
  TextRegular,
  Title,
} from "../../styles/GlobalStyledComponents";
import {
  ContinuationImg,
  ContinuationStep,
  ContinuationStepsRow,
  ContinuationText,
  ReminderText,
  VerticalLine,
} from "./ContinuationStyledComponents";

import ShoppingBag from "../../assets/images/continuation/shopping-bag.svg";
import OkHand from "../../assets/images/continuation/ok-hand.svg";
import Calendar from "../../assets/images/continuation/calendar.svg";
import {
  DetailsBox,
  DetailsPlaceholder,
  DetailsTitle,
  InfoLink,
  WrapperBox,
  WrapperBoxSection,
  WrapperBoxElement,
  DetailsSectionTitle,
  DetailsSectionAmount,
  DetailsSectionSubtitle,
} from "../Entry/StyledComponents";
import { useLoanSimulation } from "./../../contexts/LoanSimulationContext/loan-context.hook";
import { useNavigate } from "react-router-dom";
import { ROUTES_PATH } from "../../constants";
import { useCreditProposalResult } from "./../../contexts/CreditProposalResultContext/creditProposalResult-hook";

interface ContinuationProps {
  loadingEvent: (data?: any) => void;
}

export const Continuation: React.FC<ContinuationProps> = ({ loadingEvent }) => {
  const navigate = useNavigate();
  const [showInfo, setShowInfo] = useState<boolean>(false);
  const { loanSimulation } = useLoanSimulation();
  const { creditProposalResult } = useCreditProposalResult();

  const handleContinue = () => {
    loadingEvent(true);
    if (creditProposalResult?.flow_step === "OCR") {
      navigate(ROUTES_PATH.OCR);
    } else if (creditProposalResult?.product === "PLS") {
      navigate(ROUTES_PATH.BANKREADER);
    } else {
      navigate(ROUTES_PATH.PAYMENT);
    }
  };

  return (
    <>
      <ContinuationText>
        <Title>Cómpralo hoy, págalo en {loanSimulation?.term} plazos</Title>
        <Subtitle>
          Disfruta de las ventajas de Pepper. ¡Puedes realizar tus compras hoy y
          pagarlas en {loanSimulation?.term} cómodos plazos!
        </Subtitle>
      </ContinuationText>
      <ContinuationStepsRow>
        <ContinuationStep>
          <ContinuationImg src={ShoppingBag} />
          <TextRegular $fontSize={12} $color={"gray9"}>
            Compras hoy por
          </TextRegular>
          <TextBold $fontSize={12}>
            {loanSimulation?.first_fee.toFixed(2).toString().replace(".", ",")}€
          </TextBold>
        </ContinuationStep>
        <VerticalLine />
        <ContinuationStep>
          <ContinuationImg src={OkHand} />
          <TextRegular $fontSize={12} $color={"gray9"}>
            {loanSimulation && loanSimulation?.term - 1} cuotas más de
          </TextRegular>
          <TextBold $fontSize={12}>
            {loanSimulation?.regular_fee
              .toFixed(2)
              .toString()
              .replace(".", ",")}
            €
          </TextBold>
        </ContinuationStep>
        <VerticalLine />
        <ContinuationStep>
          <ContinuationImg src={Calendar} />
          <TextRegular $fontSize={12} $color={"gray9"}>
            Paga una vez al mes
          </TextRegular>
          <TextBold $fontSize={12}>día 23*</TextBold>
        </ContinuationStep>
      </ContinuationStepsRow>
      <ReminderText $fontSize={10} $color={"gray9"}>
        * Te enviaremos las fechas exactas de tu plan de pago al finalizar el
        proceso
      </ReminderText>
      <DetailsBox>
        <DetailsPlaceholder>
          <DetailsTitle>Detalle de tu solicitud</DetailsTitle>
          <InfoLink
            id="entry-info-toggle"
            onClick={() => setShowInfo(!showInfo)}
          >
            {showInfo ? "-" : "+"} Info
          </InfoLink>
        </DetailsPlaceholder>
        <WrapperBox showinfo={showInfo ? "open" : "close"}>
          <WrapperBoxSection>
            <WrapperBoxElement>
              <DetailsSectionTitle>Importe de la compra</DetailsSectionTitle>
            </WrapperBoxElement>
            <WrapperBoxElement>
              <DetailsSectionAmount>
                {loanSimulation &&
                  parseInt(
                    loanSimulation.financed_amount
                      .toFixed(2)
                      .toString()
                      .replace(".", ",")
                  )
                    .toFixed(2)
                    .toString()
                    .replace(".", ",")}{" "}
                €
              </DetailsSectionAmount>
            </WrapperBoxElement>
          </WrapperBoxSection>
          <WrapperBoxSection>
            <DetailsSectionSubtitle>
              TIN {loanSimulation?.tin.toFixed(2).toString().replace(".", ",")}%
              | TAE{" "}
              {loanSimulation?.tae.toFixed(2).toString().replace(".", ",")}% |
              Com.Apertura{" "}
              {loanSimulation?.opening_fee
                .toFixed(2)
                .toString()
                .replace(".", ",")}
              €
              {loanSimulation?.opening_fee !== 0 && (
                <DetailsSectionSubtitle> financiada</DetailsSectionSubtitle>
              )}
            </DetailsSectionSubtitle>
          </WrapperBoxSection>
          <WrapperBoxSection margin="0.5rem 0 0">
            <WrapperBoxElement>
              <DetailsSectionTitle>Importe total adeudado</DetailsSectionTitle>
            </WrapperBoxElement>
            <WrapperBoxElement>
              <DetailsSectionAmount>
                {loanSimulation?.total_cost
                  .toFixed(2)
                  .toString()
                  .replace(".", ",")}{" "}
                €
              </DetailsSectionAmount>
            </WrapperBoxElement>
          </WrapperBoxSection>
          <WrapperBoxSection>
            <DetailsSectionSubtitle>
              Financiación ofrecida por Pepper Finance Corporation, S.L.U y
              sujeta a su aprobación
            </DetailsSectionSubtitle>
          </WrapperBoxSection>
        </WrapperBox>
      </DetailsBox>
      <MainButton onClick={handleContinue}>Continuar</MainButton>
    </>
  );
};
